module.exports = __webpack_public_path__ + "static/media/project_10.3e5abdda.svg";